/*
 * Sidebar link to the Jobs page.
 *
 * Named "Jobs" rather than "Backups": the page monitors every scheduled fleet action — backups and
 * the agents' own self-update — not backups alone. "Jobs" over "Backup health" for the same reason
 * it always was: a nav label that promises a verdict reads as an alarm even when everything is fine.
 * The route stays /backups (index.tsx's BACKUPS_PATH) — the label changed, not the URL.
 */
import { SidebarItem } from '@backstage/core-components';
import BackupIcon from '@material-ui/icons/Backup';

import { BACKUPS_PATH } from './index';

export function BackupsNavItem() {
  return <SidebarItem icon={BackupIcon} to={BACKUPS_PATH} text="Jobs" />;
}
